import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { Select, FormControl, MenuItem } from '@mui/material'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import {epochToDate, epochToTime, todayEpochStart, todayEpochEnd, getTodayDate} from '../components/Functions'

import 'bootstrap/dist/css/bootstrap.min.css';

import LoadingOverlay from 'react-loading-overlay';
import MuiDialogAlert from '../components/MuiDialogAlert';
const axios = require('axios').default;

var timezone_offset = 8 * 60 * 60
var defaultDate = getTodayDate();

const formData = {}

const columns = [
  { field: 'date', headerName: 'Date' },
  { field: 'time', headerName: 'Time' },
  // { field: 'station_id', headerName: 'Station ID' },
  { field: 'event_cat', headerName: 'Event Cat' },
  { field: 'event_type', headerName: 'Event Type', width: 200 },
  { field: 'details', headerName: 'Details', width: 400 }
]

function ErrorActivityLog() {

  const [loadingActive, setLoadingActive] = useState(false);
  const [modalBody, setModalBody] = useState("Update Successful");
  const [modalHeader, setModalHeader] = useState("Details");
  const [showModal, setShowModal] = useState(false);
  const [stationList, setStationList] = useState([]);

  const [selectedStation, setSelectedStation] = useState("");
  const [fromDateValue, setFromDateValue] = useState(todayEpochStart());
  const [toDateValue, setToDateValue] = useState(todayEpochEnd());

  const [showDataDiv, setShowDataDiv] = useState("hidden")
  const [eventData, setEventData] = useState([]);

  const handleClose = () => setShowModal(false);
  let navigate = useNavigate();

  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    axios.post(url, {
      "parameters": "StationReport",
      "api_user": JSON.parse(localStorage.getItem('user'))      
    })
      .then(function (response) {
        let data = response.data;
        
        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        setStationList(
          data.map((d) => {
            let tmp_json = {}
            tmp_json.id = d.station_id
            tmp_json.description = d.description
            return (tmp_json)
          }
        ))

        setSelectedStation(data[0].station_id)


        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalBody("Error Loading parameters")
        console.log(error);
      });
  }, [])

  function cellClick(e) {
    if (e.field === "details" || e.field === "event_type") {
      let tmp_json = JSON.parse(e.value)
      let msg = JSON.stringify(tmp_json, null, 4)
      setModalHeader("Details")
      setModalBody(msg)
      setShowModal(true)      
    }

  }



  function updateForm(e) {
    let id = e.target.id;
    let val = e.target.value;
    let name = e.target.name;


    if (name === "station_id") {
      setSelectedStation(val)
    }

    if (id === "from_date") {
      let tmp = (e.target.valueAsNumber / 1000) - timezone_offset
      setFromDateValue(tmp)
    }

    if (id === "to_date") {
      let tmp = (e.target.valueAsNumber / 1000) - timezone_offset + (24 * 60 * 60) - 1
      setToDateValue(tmp)
    }
  }

  function genReport() {
    let url = process.env.REACT_APP_API_SERVER + "/get_events";
    setLoadingActive(true);

    axios.post(url, {
      "event_cat": "ERROR",
      "station_id" : selectedStation,
      "from_date": fromDateValue,
      "to_date": toDateValue,
      "api_user": JSON.parse(localStorage.getItem('user'))

    })
      .then(function (response) {
        let data = response.data;
        
        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }
        
        if (data.status === "OK") {
          let tmp_array = []
          data.data.map((row) => {
            let tmp = {};
            tmp.id = row.id
            tmp.event_cat = row.event_cat
            tmp.event_type = row.event_type
            tmp.station_id = row.station_id
            tmp.date = epochToDate(row.epoch)
            tmp.time = epochToTime(row.epoch)
            tmp.details = JSON.stringify(row.details, null, 4); 
            tmp_array.push(tmp);
          })
          setEventData(tmp_array)
          setShowDataDiv("")
        } else {
          // Show error msg
          setModalHeader("Error")
          setModalBody("Unable to get list of events")
          setShowModal(true)      
        }
        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error")
        setModalBody(error)
        console.log(error);
      });

  }
  return (
    <div align="left" style={{ height: "100%" }}>
      <LoadingOverlay
        active={loadingActive}
        spinner
        text="Loading"
        className="spinner_div"
      >
        <div className="form_area">
          <div>
              <table>
                <tbody>
                  <tr>
                    <td className='form-labels'>Station ID</td>
                    <td className='form-labels'>Start Date</td>
                    <td className='form-labels'>End Date</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style={{ paddingRight: "15px" }}>

                      <FormControl fullWidth>
                        <Select
                          id="station_id"
                          name="station_id"
                          variant="outlined"
                          value={selectedStation}
                          onChange={updateForm}
                          sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            '& .MuiSelect-select': { fontSize: 14 }
                          }}
                          style={{ width: "200px" }}
                        >
                        {
                          stationList.map((station) => {
                            return <MenuItem key={station.id} value={station.id}>
                              {station.description}
                            </MenuItem>
                          })
                        }
                        </Select>
                      </FormControl>
                    </td>
                    <td style={{ paddingRight: "15px" }}>
                      <div>
                        <TextField
                          id="from_date"
                          type="date"
                          defaultValue={defaultDate}
                          onChange={updateForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            '& .MuiInputBase-input': { fontSize: 14 }
                          }}
                        />
                      </div>
                    </td>
                    <td style={{ paddingRight: "15px" }}>
                      <TextField
                        id="to_date"
                        type="date"
                        defaultValue={defaultDate}
                        onChange={updateForm}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                          '& .MuiInputBase-input': { fontSize: 14 }
                        }}
                      />
                    </td>
                    <td style={{ paddingRight: "15px" }}>
                      <Button
                        variant="contained"
                        color="success"
                        onClick={genReport}
                        sx={{ width: 120, height: 50 }}
                      >
                        Generate
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>

          <div style={{ height: "30px" }}></div>

          <div className={showDataDiv}>

            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={eventData}
                columns={columns}
                pageSize={50}
                disableVirtualization
                components={{ Toolbar: GridToolbar }}
                onCellClick = {cellClick}
                sx ={{
                  '& .MuiTablePagination-selectLabel': {paddingTop: '15px'},
                  '& .MuiTablePagination-displayedRows': {paddingTop: '15px'},
                  '& .MuiDataGrid-cell': { fontSize: 12 },
                  '& .MuiDataGrid-columnHeader': { fontSize: 12 }

                }}
              />
            </div>

          </div>

          <MuiDialogAlert 
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"          
          />

        </div>
      </LoadingOverlay>
    </div> 
  )
}

export default ErrorActivityLog